import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import Swal from 'sweetalert2';
import { User } from 'src/app/shared/models/user.model';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { UserService } from 'src/app/shared/service/user.service';
import { Location } from '@angular/common';
import { NbDialogRef } from '@nebular/theme';
import { HttpError } from 'src/app/shared/models/http-error.model';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-private-notification',
  templateUrl: './private-notification.component.html',
  styleUrls: ['./private-notification.component.scss']
})
export class PrivateNotificationComponent implements OnInit, OnDestroy {
  private readonly sub = new SubSink();
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  message!: string;
  title!: string;
  user!: User;
  loading = false;
  error: any = {};

  constructor(
    private notificationService: NotificationService,
    private userService: UserService,
    private location: Location,
    private route: ActivatedRoute,
    @Optional() protected dialogRef: NbDialogRef<any>
  ) {
  }

  onSubmit(): void {
    this.error = {};
    this.loading = true;
    this.sendNotification();
  }

  sendNotification() {
    this.notificationService.createPrivateNotification(this.title, this.message, this.user?.id).subscribe(
      (Response) => {
        if (Response.status === 'OK') {
          this.Toast.fire({
            icon: 'success',
            title: 'اطلاعیه با موفقیت ارسال شد'
          });
        }
        this.loading = false;
        this.dialogRef.close();
      },
      (response: HttpError) => {
        if (response.status === 422) {
          this.error = response.validationError;
        } else {
          this.Toast.fire({icon: 'error', title: response.error});
        }
        this.loading = false;
      }
    );
  }

  ngOnInit(): void {
    if (Object.keys(this.location.getState() as {}).includes('id')) {
      this.user = new User(this.location.getState());
    }
    const userIdParam = this.route.snapshot.params['user-id'];
    if (userIdParam) {
      this.sub.sink = this.userService.getUserInfo(userIdParam).subscribe((user) => this.user = user);
    }
  }

  public ngOnDestroy() {
    this.sub.unsubscribe()
  }
}
